/* eslint-disable class-methods-use-this */
const { orderType, sourceAndDestinationType, chargeCode } = require('pando-constants');
const { freightUnit } = require('../../constants/payments');
const convertWeight = require('../../helpers/weightConverter');
const Helper = require('./utils/helper');
const convertVolume = require('../../helpers/volumeConverter');

class Appointment {

  getMaxChargeOfConsigneeGroup(_group, consigneeGroup, amount) {
    let charge = 0;
    const group = _group;
    if (!group[consigneeGroup]) {
      group[consigneeGroup] = 0;
    }
    if (amount > group[consigneeGroup]) {
      charge = (amount - group[consigneeGroup]);
      group[consigneeGroup] = amount;
    }
    return charge;
  }

  calculateWeight(unit, materialList) {
    const destinationWeight = materialList.map(material =>
      convertWeight(material.weightUnit, unit, material.weight))
      .reduce((acc, weight) => acc + weight, 0);
    const destinationVolume = materialList.map(material =>
      convertVolume(material.volumeUnit, 'cft', material.volume))
      .reduce((acc, volume) => acc + volume, 0);
    return { weight: destinationWeight, volume: destinationVolume };
  }

  calculateQuantity(materialList, unitType, contractCharge) {
    const kg = 'kg';
    let charge = 0;
    if(unitType === freightUnit.per_kg) {
      const { weight, volume } = this.calculateWeight(kg, materialList);
      charge =  (Math.max(weight,volume)) * contractCharge;
    } else if (unitType === freightUnit.per_trip) {
      charge = contractCharge;
    }
    return charge;
  }

  calculateAppointmentCharge(destination, data,
    clientConfig, destinationAppointmentCharges, gateId) {
    let appointmentDestinationCharge = 0;
    const destinationCharge = destinationAppointmentCharges && destinationAppointmentCharges.find(charge =>
      charge.destination_id.toString() === destination.locationId.toString());
      const materials = Helper.getNormalizedMaterialDetails(destination.materials);
      if (destinationCharge) {
        const charges = destinationCharge.charges;
        if (charges.length) {
          //fetching first element as Raymond will fetch for single row of data
          appointmentDestinationCharge = Math.max(this.calculateQuantity(
            materials, charges[0].charge_unit, charges[0].charge), charges[0].min_charge);
        }
      }
    return appointmentDestinationCharge;
  }

  appointmentCharge(data, clientConfig = {}) {
    const freightContracts = data.freightCharges;
    if (data.orderType === orderType.CONTRACT) {
      // added filter since secondary consignees will not have gate id
      const group = {};
      let appointmentCharge = 0;
      const destinationAppointmentCharges = data.indentDestinationCharges && data.indentDestinationCharges.filter(charge =>
        charge.charge_code === chargeCode.APPOINTMENT_CHARGE);
      data.destinations.forEach((destination) => {
        const gateId = destination.locationId;
        // added condition here since secondary consignees will not have gate id
        if (destination.type !== sourceAndDestinationType.CONSIGNEE) {
            const amount = this.calculateAppointmentCharge(destination, data,
              clientConfig, destinationAppointmentCharges, gateId);
            appointmentCharge += (destination.type === sourceAndDestinationType.CONSIGNEE && destination.group && destination.group.length) ?
              this.getMaxChargeOfConsigneeGroup(group, destination.group, amount) : amount;
        } else {
          const amount = this.calculateAppointmentCharge(destination, data,
            clientConfig, destinationAppointmentCharges);
          appointmentCharge += (destination.type === sourceAndDestinationType.CONSIGNEE && destination.group && destination.group.length) ?
            this.getMaxChargeOfConsigneeGroup(group, destination.group, amount) : amount;
        }
      });
      return appointmentCharge;
    }
    return 0;
  }
}
module.exports = Appointment;
